import { toast, ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import apiOrder from "../../apis/api.order";

function PaymentTest(){
    const { orderId } = useParams();

    const handleClickPaymentSuccess = async() =>{
        const res = await apiOrder.updateOrderSuccess(orderId);
        if(res){
            toast.success("thanh toan thanh cong")
        }
        else{
            toast.error("Thanh toan that bai")
        }
    }

    const handleClickPaymentFailure = async () =>{
        const res = await apiOrder.updateOrderFailure(orderId);
        if(res){
            toast.success("thanh toan thanh cong")
        }
        else{
            toast.error("Thanh toan that bai")
        }
    }

    return(
        <>
        <ToastContainer/>

        <button onClick={() => handleClickPaymentSuccess()}> Thanh toán thành công</button>

        <button onClick={() => handleClickPaymentFailure()}> Thanh toán thất bại</button>
        
        </>
    )

}

export default PaymentTest;